import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-custom__content form-custom"
}
const _hoisted_4 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-field-label mb-3" }
const _hoisted_7 = { class: "d-flex mb-4" }
const _hoisted_8 = {
  class: "p-field-label mt-1",
  for: "scsAddr"
}
const _hoisted_9 = {
  for: "scsAddr",
  class: "fs-13 label-error"
}
const _hoisted_10 = { class: "p-field-label mt-5 mb-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mt-4 mb-3 secondary-label fw-normal fs-12 text-uppercase" }
const _hoisted_14 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonSelection = _resolveComponent("ButtonSelection")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    (_ctx.currentGate)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (!_ctx.changingGate)
              ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                  key: 0,
                  class: "list"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("SelectDevicesInGate")), 1)
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_ButtonSelection, {
                        class: "ml-1 mr-4",
                        icon: require(`@/assets/images/entrancePlants/icon-new-pe.svg`)
                            ,
                        label: _ctx.$t('AppResourceEP.NewPeDevice'),
                        modelValue: _ctx.currentGate.newPeSelected,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentGate.newPeSelected = $event)),
                        disabled: _ctx.newPeDisabled
                      }, null, 8, ["icon", "label", "modelValue", "disabled"]),
                      _createVNode(_component_ButtonSelection, {
                        class: "mr-4",
                        icon: require(`@/assets/images/entrancePlants/icon-keypad.svg`)
                        ,
                        label: _ctx.$t('AppResourceEP.KeyPad'),
                        modelValue: _ctx.currentGate.keypadSelected,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentGate.keypadSelected = $event)),
                        disabled: _ctx.keypadDisabled
                      }, null, 8, ["icon", "label", "modelValue", "disabled"]),
                      _createVNode(_component_ButtonSelection, {
                        class: "mr-4",
                        icon: require(`@/assets/images/entrancePlants/icon-smart-reader.svg`)
                        ,
                        label: _ctx.$t('AppResourceEP.SmartReader'),
                        modelValue: _ctx.currentGate.smartReaderSelected,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentGate.smartReaderSelected = $event)),
                        disabled: _ctx.smartReaderDisabled
                      }, null, 8, ["icon", "label", "modelValue", "disabled"])
                    ]),
                    _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.DeviceScsAddress")), 1),
                    _createVNode(_component_InputText, {
                      id: "scsAddr",
                      class: {'input-error': _ctx.scsAddrNotValid},
                      type: "number",
                      style: {"width":"40%"},
                      min: _ctx.MIN_SCS_ADDRESS,
                      max: _ctx.MAX_SCS_ADDRESS,
                      modelValue: _ctx.currentGate.scsAddress,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentGate.scsAddress = $event))
                    }, null, 8, ["class", "min", "max", "modelValue"]),
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.invalidScsReason), 1)
                    ]),
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.SetupDefineGatesBuildingGovern")), 1),
                    (_ctx.plant.buildings && _ctx.currentGateId)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode(_component_ListItemCheck, {
                            label: _ctx.$t('AppResource.All'),
                            inputId: "AllBuilding",
                            name: "building",
                            modelValue: _ctx.allBuildings[_ctx.currentGateId],
                            "onUpdate:modelValue": [
                              _cache[5] || (_cache[5] = ($event: any) => (_ctx.allBuildings[_ctx.currentGateId] = $event)),
                              _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleUpdateBuildingSelection(_ctx.AllBuildingsValue)))
                            ],
                            binary: ""
                          }, null, 8, ["label", "modelValue"]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.plant.buildings, (building, i) => {
                            return (_openBlock(), _createBlock(_component_ListItemCheck, {
                              key: i,
                              last: i == _ctx.plant.buildings.length - 1,
                              label: building.name,
                              value: building.buildingId,
                              inputId: 'building' + i,
                              name: "building",
                              modelValue: _ctx.selectedBuildingIds[_ctx.currentGateId],
                              "onUpdate:modelValue": [
                                _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedBuildingIds[_ctx.currentGateId] = $event)),
                                ($event: any) => (_ctx.handleUpdateBuildingSelection('', building.buildingId))
                              ]
                            }, null, 8, ["last", "label", "value", "inputId", "modelValue", "onUpdate:modelValue"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isBRFA && _ctx.currentGateId)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedBuildings, (b, i) => {
                            return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                              _createVNode("div", _hoisted_13, [
                                _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.For")) + " " + _toDisplayString(b.name) + " " + _toDisplayString(_ctx.$t("TheyManage")), 1)
                              ]),
                              (b && b.risers && b.buildingId)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_ListItemCheck, {
                                      label: _ctx.$t('AppResourceEP.SetupDefineGatesBuildingAllRisers'),
                                      inputId: "AllRisers_b_{{b.buildingId}}",
                                      name: "riser",
                                      modelValue: _ctx.allRisers[_ctx.currentGateId][b.buildingId],
                                      "onUpdate:modelValue": [($event: any) => (_ctx.allRisers[_ctx.currentGateId][b.buildingId] = $event), ($event: any) => (_ctx.handleUpdateRiserSelection(_ctx.AllRisersValue, b.buildingId))],
                                      binary: ""
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(b.risers, (riser, i) => {
                                      return (_openBlock(), _createBlock(_component_ListItemCheck, {
                                        key: i,
                                        last: i == b.risers.length - 1,
                                        label: riser.name,
                                        value: riser.riserId,
                                        inputId: 'riser' + i,
                                        name: "riser",
                                        modelValue: _ctx.selectedRiserIds[_ctx.currentGateId][b.buildingId],
                                        "onUpdate:modelValue": [($event: any) => (_ctx.selectedRiserIds[_ctx.currentGateId][b.buildingId] = $event), ($event: any) => (_ctx.handleUpdateRiserSelection('', b.buildingId))]
                                      }, null, 8, ["last", "label", "value", "inputId", "modelValue", "onUpdate:modelValue"]))
                                    }), 128))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("footer", _hoisted_14, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: !_ctx.nextEnabled
      }, null, 8, ["onClick", "label", "disabled"])
    ])
  ], 64))
}